export default __webpack_public_path__ + "static/media/24.6e08c610.png";